var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgDefaultCard = function SvgImgDefaultCard(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 138,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "33.366%",
    x2: "55.569%",
    y1: "98.612%",
    y2: "59.958%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3E3A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3E3A39",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "71.379%",
    x2: "32.929%",
    y1: "19.759%",
    y2: "58.898%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3E3A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3E3A39",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M0 0h180v138H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    d: "M101.997 71.512a13.057 13.057 0 0 0-4.714-5.726l-.119-.077a10.49 10.49 0 0 0 3.36-7.708h.001a10.5 10.5 0 0 0-4.638-8.724 10.487 10.487 0 0 0-5.885-1.799 10.507 10.507 0 0 0-8.725 4.638A10.491 10.491 0 0 0 79.48 58a10.5 10.5 0 0 0 3.36 7.707 13.077 13.077 0 0 0-3.631 3.591 12.978 12.978 0 0 0-2.225 7.281c0 1.79.364 3.51 1.024 5.068a13.056 13.056 0 0 0 8.125 7.365c1.224.381 2.527.586 3.87.586 1.79 0 3.51-.364 5.068-1.024a13.056 13.056 0 0 0 7.365-8.125c.381-1.224.586-2.527.586-3.87 0-1.79-.364-3.51-1.024-5.068zm-11.995-19.07a5.56 5.56 0 0 1 5.56 5.56c0 .774-.156 1.499-.436 2.162a5.59 5.59 0 0 1-3.47 3.147 5.56 5.56 0 1 1-1.654-10.87zm0 32.194a8.056 8.056 0 0 1-8.056-8.056c0-1.12.226-2.172.632-3.135a8.096 8.096 0 0 1 5.028-4.559 8.045 8.045 0 0 1 2.396-.362 8.056 8.056 0 1 1 0 16.112z"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M24.505 3.908a10.498 10.498 0 0 0-.591-2.903l-.016.007-4.515 2.068-.015.007a5.542 5.542 0 0 1-.243 3.617 5.59 5.59 0 0 1-3.47 3.147 5.537 5.537 0 0 1-1.4.243c1.248.025 2.46.225 3.603.58 1.185.37 2.295.904 3.307 1.573a10.49 10.49 0 0 0 3.36-7.706c0-.212-.008-.423-.02-.633z",
    transform: "translate(76 53.462)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M14.238 15.062c-.088-.003-.155-.008-.244-.008h-.011c-1.084 0-2.133-.171-3.122-.48a10.482 10.482 0 0 1-2.755-1.323l-1.271-1.005a13.077 13.077 0 0 0-3.631 3.592 12.977 12.977 0 0 0-2.206 7.985l5.11-2.34c.107-.52.264-1.021.466-1.5a8.095 8.095 0 0 1 5.028-4.558 8.05 8.05 0 0 1 2.818-.351c-.056-.003-.126-.01-.182-.012z",
    transform: "translate(76 53.462)"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgDefaultCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img_default_card.ca4da640eae99536fcb4329bf3bc284b.svg";